<template>
  <main>
    <div class="container">
      <div class="row row-vertical-align-center">
        <div v-if="!promotionalMerchants" class="col-full margin-bottom-md">
          <i class="icon-success icon-size-sm" />
        </div>
        <div class="col-full">
          <h1 class="display-xl margin-bottom-lg">
            {{ $t('emailConfirmation.heading') }}
            <span class="color-orange-high">{{ $t('emailConfirmation.subheading') }}</span>
          </h1>
          <p>
            {{ $t('emailConfirmation.description') }}
          </p>
        </div>
      </div>
      <al-carousel v-if="promotionalMerchants" name="merchant-carousel">
        <al-carousel-item
          v-for="merchant in promotionalMerchants"
          :key="merchant.name"
          :image-url="`./assets/img/${merchant.name}.png`"
          :cta-url="merchant.url"
          :name="merchant.name"
          @click.native="logAnalytics(merchant)" />
      </al-carousel>
      <div class="row-vertical-align-bottom">
        <div class="col-full align-center">
          <button class="btn--underlined" type="button" data-test="primary-cta" @click="route()">
            {{ $t(cta) }}
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlCarousel, AlCarouselItem } from '@mc-alberta/alcapone'
import shuffle from 'lodash.shuffle'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ACTION, PROMOTIONAL_MERCHANTS, ROUTES } from '@/constants'

export default {
  name: 'EmailConfirmation',
  components: { AlCarousel, AlCarouselItem },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      currentCountry: (state) => state.user.consumer.countryCode
    }),
    cta() {
      return this.isLoggedIn ? 'button.continue' : 'button.signIn'
    },
    promotionalMerchants() {
      const countryConfig = this.$i18nData.getCountryConfig(this.currentCountry)
      let promotionalMerchants = countryConfig?.promotionalMerchants
      promotionalMerchants = promotionalMerchants?.filter(
        (merchants) => merchants.name !== PROMOTIONAL_MERCHANTS.PRICELESS_PLANET
      )
      return promotionalMerchants ? shuffle(promotionalMerchants) : false
    }
  },
  methods: {
    ...mapActions(['setAction']),
    route() {
      this.setAction(ACTION.MANAGE)

      if (this.isLoggedIn) {
        this.$router.replace({ name: ROUTES.PROFILE_HOME })
      } else {
        this.$router.replace({ name: ROUTES.ENTRY })
      }
    },
    logAnalytics(merchant) {
      const { name, url } = merchant
      this.$analytics.track({
        event: this.$EVENTS.MERCHANT_LOGO_CLICK,
        meta: {
          merchantName: name,
          merchantUrl: url
        }
      })
    }
  }
}
</script>
